require('./assign-agent-config-tab.component.scss');
class AssignAgentConfigTabController {
  constructor(
    $scope,
    $http,
    PermissionService,
  ) {
    this.$scope = $scope;
    this.permission = PermissionService;
    $scope.configs = {
      // accountConf: [],
      agentConf: [],
    };

    if (!$scope.filter.switch_to) {
      $scope.filter.switch_to = {
        // accountConf: null,
        agentConf: "",
        enabled: false
      };
    }

    $http.get('/analytics/configs_lists/').then(data => {
      this.$scope.configs = {
        // accountConf: this.setName(data.data.object_list.AccountConf),
        agentConf: this.setName(data.data.object_list.AgentConf),
      };
      let conf_id = $scope.filter.switch_to.agentConf;
      if( -1 === this.$scope.configs.agentConf.findIndex(item => item.id === +conf_id)) {
        // Drop config id to null if it does not exist
        $scope.filter.switch_to.agentConf = "";
      }
    });
  }

  setName(list) {
    const nameKey = this.permission.selectedLang === 'ru' ? 'name_ru' : 'name_en';
    return list.map(c => ({
      id: c.id,
      name: c[nameKey],
    }));
  }

}

export function AssignAgentConfigTabComponent() {
  return {
    restrict: 'E',
    template: require('./assign-agent-config-tab.component.html'),
    scope: false,
    controller: AssignAgentConfigTabController,
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/tabs/assign-agent-config-tab.component.js